export default __webpack_public_path__ + "static/media/facts_768.774a8326.webp";